export default "__VITE_ASSET__1ebee539__"